import { useContext, useEffect, useState } from 'react';
import { fetchUserDailyLimit } from '../api/fetchApiFns';
import { ConnectWalletContext } from '../context/ConnectWalletContext';

export const useDailyUserLimit = () => {
  const [userDailyLimit, setUserDailyLimit] = useState('');

  const tokenAddressFromStorage = localStorage.getItem('tokenAddress');
  const { tokenAddress } = useContext(ConnectWalletContext);

  useEffect(() => {
    if (tokenAddressFromStorage || tokenAddress)
      fetchUserDailyLimit(tokenAddress ? tokenAddress : tokenAddressFromStorage ? tokenAddressFromStorage : '')
        .then((res) => {
          if (typeof res === 'string') setUserDailyLimit(res);
        })
        .catch((err) => console.error(err));
    else setUserDailyLimit('');
  }, [tokenAddressFromStorage, tokenAddress]);

  return userDailyLimit;
};
